import constants from '@/libs/constant/constants'
import {isEmpty, cloneDeep, sortBy, filter} from 'lodash'
import {message, loader, urlValidation} from '@/libs/helper'
import {
    getDetails,
    updateAuthor,
    getLanguages,
    uniqueListing,
    updatePublisher,
    updatePublication,
    validateUniqueName,
    validateScreenName
} from '@/libs/api/api'

export default{
    name: 'ManageAuthorName',
    props:{
        stepBack: {
            type: Function,
            default: ()=>{}
        },
        stepForward: {
            type: Function,
            default: ()=>{}
        },
        cancel: {
            type: Function,
            default: ()=>{}
        },
        showButtons: {
            type: Boolean,
            default: ()=> true
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        updateSource: {
            type: Function,
            default: () => {}
        },
        setClaimTo: {
            type: Function,
            default: ()=> {}
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        isEdit: {
            type: Boolean,
            default: ()=> false
        },
        isStepBack: {
            type: Boolean,
            default: ()=> false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        userData: {
            type: Object,
            default: ()=>{}
        },
        adminEditButtons: {
            type: Boolean,
            default: false
        },
        isAdd: {
            type: Boolean,
            default: false
        }
    },
    beforeMount(){
        if(this.showButtons && this.claimTo._id && !this.isStepBack) {
            loader(this, true)
            getDetails(this.module.toLowerCase(), this.claimTo._id)
                .then((response)=> {
                    loader(this, false)
                    this.setClaimTo(response)
                })
                .catch((error)=> {
                    console.error(error)
                    loader(this, false)
                })
        }

        if(this.module === constants.PUBLICATION.key){
            getLanguages()
                .then((response)=>{
                    this.languages = sortBy(cloneDeep(response.languages), 'name') || []
                })
                .catch((error)=>{
                    console.error('error', error);
                })
        }

    },
    watch:{
        claimTo: function(newValue){
            this.card = {
                first_name: newValue.first_name || '',
                middle_name: newValue.middle_name || '',
                screen_name: newValue.screen_name || '',
                last_name: newValue.last_name || '',
                website: newValue.url || newValue.website || ''
            }
            if (this.card && this.card.website && this.card.website.includes('https://')) this.card.website = this.card.website.replace('https://', "")
            if (this.card && this.card.website && this.card.website.includes('http://')) this.card.website = this.card.website.replace('http://', "")
            this.publisher = {
                name: newValue.name || '',
                website: newValue.url && newValue.url.length > 0 ? newValue.url[0] : newValue.website && newValue.website.length > 0 ? newValue.website[0] : '',
                screen_name: newValue.screen_name || '',
                registration_number: newValue.registration_number || ''
            }

            if (this.publisher && this.publisher.website && this.publisher.website.includes('https://')) {
            this.publisher.website = this.publisher.website.replace('https://', "")
            } else if (this.publisher && this.publisher.website && this.publisher.website.includes('http://')) {
                this.publisher.website = this.publisher.website.replace('http://', "")
            }

            this.publication = {
                name: newValue.name || '',
                screen_name: newValue.screen_name  || '',
                language: (newValue.language) || {},
                language_name: (newValue.language && newValue.language.display_name) || ''
            }
        },
        userData (newValue) {
            this.user= {
                _id : newValue._id,
                first_name: newValue.first_name,
                last_name: newValue.last_name,
                middle_name: newValue.middle_name,
                email: newValue.email
            }
        }
    },
    data(){
        return {
            isEmpty,
            languages:[],
            user: {
                _id: '',
                first_name: '',
                last_name: '',
                middle_name: '',
                email: ''
            },
            card: {
                first_name: this.claimTo.first_name || '',
                middle_name: this.claimTo.middle_name || '',
                last_name: this.claimTo.last_name || '',
                website: this.getAuthorWebsite(),
                screen_name: this.claimTo.screen_name || '',
            },

            publisher: {
                name: this.claimTo.name || '',
                website: this.getWebsitePublisher(),
                registration_number: this.claimTo.registration_number || '',
                screen_name: this.claimTo.screen_name || '',
            },

            publication: {
                name: this.claimTo.name || '',
                screen_name: this.claimTo.screen_name || '',
                language: (this.claimTo.language) || {},
                language_name: (this.claimTo.language && this.claimTo.language.display_name) || ''
            },
            webSiteValidation: function (rule, value, callback) {
                if (isEmpty(value)) callback(new Error(window.i18next.t('Field should not be empty'))) 
                if (value && value !== '' && (value.includes('http://') || value.includes('https://'))) callback(new Error(window.i18next.t('Try adding url without web protocols(http or https)')))
                if (!urlValidation('https://' + value)) callback(new Error(window.i18next.t('Incorrect url'))) 
                else callback()
            },
            adminWebsiteValidation (rule, value, callback) {
                if (!isEmpty(value) && value.includes('http')) callback(new Error('Try adding url without web protocols(http or https)'))
                if (!isEmpty(value) && !urlValidation('https://' + value)) callback(new Error('Incorrect url'))
                else callback() 
            },
            nameLimitValidation: function (rule, value, callback) {
                if(rule.field === 'middle_name' && value.split('').length === 0 ){
                    callback();
                } else if(value.split('').length < 2){
                    callback(new Error(window.i18next.t('Minimum 2 character required')));
                } else{
                    callback();
                }
            },
            validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if (this.isAdmin) {
                    if (!isEmpty(value) && (value.length > 20)) callback(new Error('Invalid screen name'))
                    if (!isEmpty(value) && regex.test(value)) callback(new Error('Invalid screen name'))
                    if (!isEmpty(value) && checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                    else callback()
                } else {
                    if (isEmpty(value) || (value && value.length > 20)) callback(new Error(window.i18next.t('Invalid screen name')))
                    if (regex.test(value)) callback(new Error(window.i18next.t('Invalid screen name')))
                    if (checkSpaces.test(value)) callback(new Error(window.i18next.t('Spaces are not allowed')))
                    else callback()
                }
            },
        }
    },
    methods: {
        getAuthorWebsite () {
            let website = (this.claimTo && this.claimTo.url) || ''
            if (website === undefined || website === null || website === '') website = ''
            if (website.includes('https://')) website = website.replace(('https://', ' ')).trim()            
            else if (website.includes('http://')) website = website.replace(('http://', ' ')).trim()
            return website
        },

        getWebsitePublisher() {
            if (this.claimTo.url && this.claimTo.url.length > 0 && this.claimTo.url[0] && this.claimTo.url[0].includes('https://')) {
            return this.claimTo.url[0].replace('https://', "")
            } else if (this.claimTo.website && this.claimTo.website.length > 0 && this.claimTo.website[0] && this.claimTo.website[0].includes('http://')) {
                return this.claimTo.website[0].replace('http://', "")
            } else {
                return ''
            }
        },

        getHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Basic Author settings'
                case constants.PUBLISHER.key:
                    return 'Basic Publisher settings'
                case constants.PUBLICATION.key:
                    return 'Basic Publication settings'
                case 'USER': 
                    return 'User Name'   
            }
        },
        getSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Basic settings of this Author. These settings will be used to create the profile of the Author in the Information Portal'
                case constants.PUBLISHER.key:
                    return 'Basic Settings of this Publisher. These settings will be used to create the profile of this publisher in the Information Portal'
                case constants.PUBLICATION.key:
                    return 'Basic Settings of this Publication. These settings will be used to create the profile of this publication in the Information Portal'
                case 'USER': 
                    return 'Basic Settings of this User. These settings will be used to create the profile of this User in the Information Portal'

            }
        },
        submitAuthorForm (formName) {
            this.$refs[formName].validate((valid) => {
                if(!valid){
                    return
                }

                loader(this, true)
                
                let body = {
                    url: `https://${this.card.website}`,
                    first_name: this.card.first_name,
                    last_name: this.card.last_name,
                    type: this.module
                }
                
                if(this.claimTo._id){
                    body.id = this.claimTo._id
                }

                if(this.card.middle_name !== ''){
                    body.middle_name = this.card.middle_name
                }

                uniqueListing(body).then((response)=>{
                    loader(this, false)
                    if(response.is_unique){
                        let claimTo = this.claimTo
                        claimTo.first_name = this.card.first_name
                        claimTo.middle_name = this.card.middle_name
                        claimTo.last_name = this.card.last_name
                        claimTo.website = this.card.website
                        if (!this.isAdd) this.stepForward()
                    } else {
                        message(this, constants.messageType.ERROR, ('This set is already available'))
                    }
                }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            })
        },
        submitAuthorEditForm: async function (formName){
            this.$refs[formName].validate(async(valid) => {
                if (!valid) {
                    return false
                }

                loader(this, true)

                /**
                 * uncomment if required to validate screen name now it is in read only in edit forms
                 */

                // let result = await this.validateMetaScreenName()
                // if (!result.isUnique) {
                //     message(this, constants.messageType.ERROR, 'Screen name is already taken')
                //     loader(this, false)
                //     return
                // } 

                let body = {
                    first_name: this.card.first_name,
                    middle_name: this.card.middle_name,
                    screen_name: this.card.screen_name,
                    last_name: this.card.last_name,
                    url: `https://${this.card.website}`
                }

                if(body.middle_name === ''){
                    delete body.middle_name
                }

                updateAuthor(body, this.claimTo._id)
                    .then((response)=>{
                        let claimTo = cloneDeep(this.claimTo)

                        let name = this.card.first_name

                        if(this.card.middle_name !== ''){
                            name = `${name} ${this.card.middle_name}`
                        }

                        if(this.card.last_name !== ''){
                            name = `${name} ${this.card.last_name}`
                        }

                        claimTo.first_name = this.card.first_name
                        claimTo.last_name = this.card.last_name
                        claimTo.website = this.card.website
                        claimTo.url = this.card.website
                        claimTo.screen_name = this.card.screen_name
                        claimTo.name = name
                        claimTo.middle_name = this.card.middle_name
                        this.setClaimTo(claimTo)
                        this.updateSource('NAME', claimTo)
                        this.$store.dispatch('updateRegisteredAuthor', claimTo)
                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, (response.message))
                    })
                    .catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
            })
        },
        submitPublisherForm(formName){
            this.$refs[formName].validate((valid) => {
                if(!valid){
                    return
                }

                loader(this, true)

                let body = {
                    url: this.publisher.website,
                    name: this.publisher.name,
                    type: this.module
                }

                if(this.claimTo._id){
                    body.id = this.claimTo._id
                }

                uniqueListing(body).then((response)=>{
                    loader(this, false)
                    if(response.is_unique){
                        let claimTo = this.claimTo
                        let website = claimTo.url || []
                        let url = claimTo.url || []
                        claimTo.name = this.publisher.name
                        url[0] = this.publisher.website
                        claimTo.url = url
                        website[0] = this.publisher.website
                        claimTo.website = website
                        claimTo.registration_number = this.publisher.registration_number
                        this.stepForward()
                    } else {
                        message(this, constants.messageType.ERROR, ('This set is already available'))
                    }
                }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            })
        },
        submitPublisherEditForm(formName){
            this.$refs[formName].validate(async(valid) => {
                if (!valid) {
                    return
                }

                loader(this, true)

                /**
                 * uncomment if required to validate screen name now it is in read only in edit forms
                 */

                // let result = await this.validateMetaScreenName()
                // if (!result.isUnique) {
                //     message(this, constants.messageType.ERROR, 'Screen name is already taken')
                //     loader(this, false)
                //     return
                // } 

                let body = {
                    url: `https://${this.publisher.website}`,
                    name: this.publisher.name,
                    screen_name: this.publisher.screen_name,
                    registration_number: this.publisher.registration_number
                }

                updatePublisher(body, this.claimTo._id)
                    .then((response)=>{
                        let claimTo = cloneDeep(this.claimTo)

                        claimTo.url[0] = this.publisher.website
                        claimTo.name = this.publisher.name
                        claimTo.registration_number = this.publisher.registration_number
                        claimTo.screen_name = this.publisher.screen_name
                        this.setClaimTo(claimTo)
                        this.updateSource('NAME', claimTo)
                        this.$store.dispatch('updateRegisteredPublisher', claimTo)
                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, (response.message))
                    })
                    .catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
            })
        },
        submitPublicationForm(formName){
            this.$refs[formName].validate((valid) => {
                if(!valid){
                    return
                }

                loader(this, true)

                let body = {
                    url: this.publication.website,
                    name: this.publication.name,
                    type: this.module
                }

                if(this.claimTo._id){
                    body.id = this.claimTo._id
                }

                uniqueListing(body).then((response)=>{
                    loader(this, false)
                    if(response.is_unique){
                        let claimTo = this.claimTo

                        claimTo.name = this.publication.name
                        claimTo.language = this.publication.language
                        claimTo.website = this.publication.website

                        this.stepForward()
                    } else {
                        message(this, constants.messageType.ERROR, ('This set is already available'))
                    }
                }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            })
        },
        validateMetaScreenName: async function () {
            // body for api
            let body = {
                entity_id: this.claimTo._id,
                entity_type: this.module,
                screen_name: this.module === constants.PUBLICATION.key ? this.publication.screen_name : this.module === constants.PUBLISHER.key ? this.publisher.screen_name : this.card.screen_name
            }
            // api call
            return validateScreenName(body)
        },
        submitPublicationEditForm(formName){
            this.$refs[formName].validate(async(valid) => {
                if (!valid) {
                    return
                }

                loader(this, true)
                
                /**
                 * uncomment if required to validate screen name now it is in read only in edit forms
                 */

                // let result = await this.validateMetaScreenName()
                // if (!result.isUnique) {
                //     message(this, constants.messageType.ERROR, 'Screen name is already taken')
                //     loader(this, false)
                //     return
                // } 
                let body = {
                    name: this.publication.name,
                    screen_name: this.publication.screen_name,
                }
                if (!isEmpty(this.publication.language)) {
                    body.language = cloneDeep(this.publication.language)
                    body.language.language_id = this.publication.language._id
                    body.language.operation= 'ADD'
                    delete body.language._id
                    delete body.language.createdAt
                    delete body.language.updatedAt
                }
                updatePublication(body, this.claimTo._id)
                    .then((response)=>{
                        let claimTo = cloneDeep(this.claimTo)

                        claimTo.url = this.publication.website
                        claimTo.name = this.publication.name
                        claimTo.language = this.publication.language
                        claimTo.screen_name = this.publication.screen_name
                        this.setClaimTo(claimTo)
                        this.updateSource('NAME', claimTo)
                        this.$store.dispatch('updateRegisteredPublication', claimTo)
                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, (response.message))
                    })
                    .catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
            })
        },
        submit(module){
            switch (module){
                case constants.AUTHOR.key:
                    this.submitAuthorForm('manageAuthorName')
                    break
                case constants.PUBLISHER.key:
                    if (this.isAdmin) {
                        this.submitAdminForm('managePublisherName')
                    }
                    else {
                        this.submitPublisherForm('managePublisherName')
                    }
                    break
                case constants.PUBLICATION.key:
                    this.submitPublicationForm('managePublicationName')
                    break
            }
        },
        submitAdminForm (formName, isTrue) {
            this.$refs[formName].validate((valid) => {
                if(!valid){
                    return
                }

                loader(this, true)

                let body = {
                    url: 'https://' + this.publisher.website,
                    name: this.publisher.name,
                    type: this.module
                }

                if(this.claimTo._id){
                    body.id = this.claimTo._id
                }
                if (this.publisher.website !== '' && this.publisher.website !== undefined) {
                    uniqueListing(body).then((response)=>{
                        loader(this, false)
                        if(response.is_unique){
                            let claimTo = this.claimTo
                            let website = claimTo.url || []
                            let url = claimTo.url || []
                            claimTo.name = this.publisher.name
                            url[0] = this.publisher.website !== '' ? 'https://' + this.publisher.website : ''
                            claimTo.url = url
                            website[0] = this.publisher.website !== '' ? 'https://' + this.publisher.website : ''
                            claimTo.website = website
                            claimTo.registration_number = this.publisher.registration_number
                           if (isTrue === undefined) this.stepForward()
                        } else {
                            message(this, constants.messageType.ERROR, ('This set is already available'))
                        }
                    }).catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
                } else {
                    validateUniqueName({name: this.publisher.name}).then((response)=>{
                        loader(this, false)
                        if(response.is_unique){
                            let claimTo = this.claimTo
                            let website = claimTo.url || []
                            let url = claimTo.url || []
                            claimTo.name = this.publisher.name
                            url[0] = this.publisher.website !== '' ? 'https://' + this.publisher.website : ''
                            claimTo.url = url
                            website[0] = this.publisher.website !== '' ? 'https://' + this.publisher.website : ''
                            claimTo.website = website
                            claimTo.registration_number = this.publisher.registration_number
                            this.stepForward()
                        } else {
                            message(this, constants.messageType.ERROR, ('This set is already available'))
                        }
                    }).catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
                }
                
            })
        },
        
        /**
         * to get the languages
         */
        queryLanguageSearch (query, cb) {
            if (query !== '' && query !== null && query.length > 1 ) {
                let results = []
                let languages = cloneDeep(this.languages)
                if (!isEmpty(languages)) {
                   results = filter(languages, (language) => {
                        return language.display_name.toLowerCase().includes(query.toLowerCase())
                    })
                }
                cb(results)
            }
        },

        /**
         * to change the language
         */
        changeLanguage (language) {
            this.publication.language = language
            this.publication.language_name = language.display_name
        },
    }
}